module.exports = __webpack_public_path__ + "img/WechatIMG3.1c8d5ffd.jpeg";